var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from "react";
import styled, { css } from "styled-components";
import { Card } from "@irati/ui/src/Layout";
import { Caption } from "@irati/ui/src/Labels";
import { H4 } from "@irati/ui/src/Headings";
import { minWidthMedia } from "@irati/ui/src/global/media";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import TrophyImg from "@irati/ui/src/Trophy";
import { maxLengthString, hasWhitespace } from "@irati/utils/string";
import getId from "@irati/utils/id";
var StyledCard = styled(Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  :hover {\n    box-shadow: none;\n  }\n"], ["\n  ",
    "\n  :hover {\n    box-shadow: none;\n  }\n"])), minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-height: 130px;\n  "], ["\n    min-height: 130px;\n  "]))));
var FlexRow = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: flex-start;\n  display: flex;\n  height: 100%;\n"], ["\n  align-items: flex-start;\n  display: flex;\n  height: 100%;\n"])));
var StyledImg = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex: none;\n  margin-right: 10px;\n  width: 60px;\n  height: 60px;\n"], ["\n  flex: none;\n  margin-right: 10px;\n  width: 60px;\n  height: 60px;\n"])));
var StyledTrophyImg = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  flex: none;\n  margin-right: 10px;\n"], ["\n  flex: none;\n  margin-right: 10px;\n"])));
var StyledDiv = styled(function (_a) {
    var whitespace = _a.whitespace, rest = __rest(_a, ["whitespace"]);
    return React.createElement("div", __assign({}, rest));
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  word-break: break-word;\n  ", "\n"], ["\n  height: 100%;\n  width: 100%;\n  word-break: break-word;\n  ",
    "\n"])), function (_a) {
    var whitespace = _a.whitespace;
    return whitespace || css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      word-break: break-all; /* need this for firefox */\n      word-break: break-word;\n    "], ["\n      word-break: break-all; /* need this for firefox */\n      word-break: break-word;\n    "])));
});
var InspirationTile = /** @class */ (function (_super) {
    __extends(InspirationTile, _super);
    function InspirationTile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            var _a = _this.props, formatMessage = _a.formatMessage, _b = _a.inspiration, desc = _b.desc, id = _b.id, isCompanyValue = _b.isCompanyValue, title = _b.title, trophy = _b.trophy, onClick = _a.onClick;
            var alt = trophy.alt, href = trophy.href;
            var data = {
                companyValues: isCompanyValue ? [id] : [],
                desc: isCompanyValue ? desc : formatMessage({ id: desc }),
                title: isCompanyValue ? title : formatMessage({ id: title }),
                trophy: {
                    alt: isCompanyValue ? alt : formatMessage({ id: alt }),
                    href: isCompanyValue ? href : formatMessage({ id: href })
                }
            };
            onClick(data);
        };
        return _this;
    }
    InspirationTile.prototype.render = function () {
        var _a = this.props, formatMessage = _a.formatMessage, inspiration = _a.inspiration, StyledTextButton = _a.StyledTextButton;
        var desc = inspiration.desc, isCompanyValue = inspiration.isCompanyValue, title = inspiration.title, trophy = inspiration.trophy;
        var idNamespace = getId("inspirationTile", this.props);
        var MAX_TITLE_LENGTH = 40;
        var MAX_CAPTION_LENGTH = 70;
        return (React.createElement(StyledTextButton, { id: idNamespace, onClick: this.handleClick, inline: false },
            React.createElement(StyledCard, { tiny: true },
                React.createElement(FlexRow, null,
                    isCompanyValue ? (React.createElement(StyledTrophyImg, null,
                        React.createElement(TrophyImg, { src: trophy.href, size: "60px" }))) : (React.createElement(StyledImg, { alt: formatMessage({ id: trophy.alt }), src: formatMessage({ id: trophy.href }) })),
                    React.createElement(StyledDiv, { whitespace: hasWhitespace({ value: title }) },
                        React.createElement(H4, { withBody: true }, isCompanyValue ? maxLengthString({ value: title, length: MAX_TITLE_LENGTH }) : React.createElement(FormattedMessage, { id: title })),
                        React.createElement(Caption, { flush: true }, isCompanyValue ? maxLengthString({ value: desc, length: MAX_CAPTION_LENGTH }) : React.createElement(FormattedMessage, { id: desc })))))));
    };
    return InspirationTile;
}(PureComponent));
export default injectIntl(InspirationTile);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
